module.exports = __webpack_public_path__ + "img/GeoAD_Flyer.cb81a126.png";